import { saveAs }                   from "file-saver";
import React, { FC, useState }      from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Icon }             from "semantic-ui-react";
import AccountOptionTypes           from "../../../domain/account/AccountOptionTypes";
import CustomerRepository           from "../../../domain/customer/CustomerRepository";
import Customers                    from "../../../domain/customer/Customers";
import Date                         from "../../../domain/fundamentals/date/Date";
import NotifyRepository             from "../../../domain/fundamentals/message/notify/NotifyRepository";
import { ResKaState }               from "../../../index";
import CustomerDataSource           from "../../../infrastructure/datasource/customer/CustomerDataSource";
import NotifyDataSource             from "../../../infrastructure/datasource/notify/NotifyDataSource";

const CustomerCsvExportButton: FC = () => {
  const [fetch, setFetch] = useState(false);
  const options: AccountOptionTypes = useSelector((state: ResKaState) => state.account.options);
  const customers: Customers = useSelector((state: ResKaState) => state.customers);
  const repository: CustomerRepository = new CustomerDataSource(useDispatch());
  const notifyRepository: NotifyRepository = new NotifyDataSource(useDispatch());

  if (!options.hasCustomerCsvExport()) {
    return null;
  }

  return (
    <>
      <Button
        icon
        labelPosition="left"
        style={ {marginLeft: "1rem"} }
        loading={ fetch }
        onClick={ () => {
          setFetch(true);
          repository.findByCsv(customers.search, customers.sortType)
            .then(response => {
              const bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
              const blob = new Blob([bom, response.data.csv], {"type": "text/csv"});
              saveAs(blob, `【ResKa】顧客情報_${ new Date().asISOText() }.csv`);
            })
            .catch(() => {
              notifyRepository.fetchFailure();
            })
            .finally(() => setFetch(false));
        } }
      >
        <Icon name="download"/>
        CSVダウンロード
      </Button>
    </>
  );
};

export default CustomerCsvExportButton;
